export default __webpack_public_path__ + "static/media/package.df387ed0.svg";